const $ = window.jQuery;

$(".c-modal").on("show.bs.modal", function () {
    if (!this.classList.contains("c-modal--login")) {
        var modal = this;
        var hash = modal.id;
        window.location.hash = hash;
        window.onhashchange = function () {
            if (!window.location.hash) {
                $(modal).modal("hide");
            }
        };
    }
});

$(".c-modal").on("hide.bs.modal", function () {
    if (!this.classList.contains("c-modal--login")) {
        history.pushState("", document.title, window.location.pathname);
    }
});
